///
/// EarthBrowser
///
/// Created by Matt Giger on September 19, 2026
/// Copyright (c) 2026 Geodata Labs
///
/// Email admin section: template preview/testing and the deliverability
/// view (send stats + suppression list).
///

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { EmailDeliverability } from './EmailDeliverability'
import { EmailTemplatePreview } from './EmailTemplatePreview'

export function EmailSection() {
  return (
    <Tabs defaultValue="templates" className="space-y-5">
      <TabsList className="rounded-full">
        <TabsTrigger value="templates" className="rounded-full">Templates</TabsTrigger>
        <TabsTrigger value="deliverability" className="rounded-full">Deliverability</TabsTrigger>
      </TabsList>
      <TabsContent value="templates">
        <EmailTemplatePreview />
      </TabsContent>
      <TabsContent value="deliverability">
        <EmailDeliverability />
      </TabsContent>
    </Tabs>
  )
}
